<template>
  <collapse :active-index="0">
    <collapse-item body-classes="p-0 m-0">
      <template slot="title">
        <h3 class="mb-0">{{ title }}</h3>
      </template>

      <div class="table-responsive">
        <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
          <el-table-column label="Articulo" min-width="145px" prop="article">
            <template #default="{ row }">
              <span class="d-block font-weight-bold">{{ row.article.description }}</span>
              <small>{{ row.article.code }}</small>
            </template>
          </el-table-column>

          <el-table-column label="Campaña" min-width="145px" prop="campaign">
            <template #default="{ row }">
              <span class="font-weight-bold">{{ row.article.campaign.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Variedad" min-width="145px" prop="variety">
            <template #default="{ row }">
              <span class="d-block">{{ row.article.variety.name }}</span>
              <small>{{ row.article.variety.crop.name }}</small>
            </template>
          </el-table-column>

          <el-table-column label="Cantidad" min-width="145px" prop="quantity">
            <template #default="{ row }">
              <span>{{ row.quantity }}</span
              >&nbsp;
              <span class="font-weight-bold">({{ row.article.variety.crop.unit.toLowerCase() }})</span>
            </template>
          </el-table-column>

          <el-table-column label="Importe (USD)" min-width="145px" prop="price">
            <template #default="{ row }">
              <span>{{ +row.price | toCurrencyUSD }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </collapse-item>
  </collapse>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  components: {
    Collapse,
    CollapseItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [PaginationMixin],
  props: {
    title: {
      type: String,
      default: 'Articulos Pedidos',
    },

    distributor: {
      type: Number,
      default: null,
    },

    producer: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      campaigns: [],
      searchKeys: [],
      orderItems: [],
    };
  },

  computed: {
    tableData() {
      return this.orderItems;
    },
  },

  created() {
    this.pagination.perPage = 500;
    this.fetchItems();
  },

  methods: {
    fetchItems() {
      const params = {
        'filter[distributor]': this.distributor,
        'filter[producer]': this.producer,
        'filter[finalized_orders]': true,
        include: ['article.campaign', 'article.variety.crop'],
      };

      this.$services
        .resource('order_items')
        .get(params)
        .then((res) => res.data.data)
        .then((data) => (this.orderItems = data.items));
    },
  },
};
</script>
